export default Object.freeze({
  NO_ASSESSMENTS: 'NO_ASSESSMENTS',
  AWAITING_ONE_ASSESSMENT: 'AWAITING_ONE_ASSESSMENT',
  AWAITING_ONE_ASSESSMENT_BY_YOU: 'AWAITING_ONE_ASSESSMENT_BY_YOU',
  ASSESSMENTS_BY_YOU: 'ASSESSMENTS_BY_YOU',
  CONFLICTED: 'CONFLICTED',
  COMPLETE: 'COMPLETE',
  COMPLETE_BY_CONFLICT_RESOLUTION: 'COMPLETE_BY_CONFLICT_RESOLUTION',

  //Screening assessments only
  RELEVANT_ASSESSMENT_BY_YOU: 'RELEVANT_ASSESSMENT_BY_YOU',
  NOT_SURE_ASSESSMENT_BY_YOU: 'NOT_SURE_ASSESSMENT_BY_YOU',
  NOT_RELEVANT_ASSESSMENT_BY_YOU: 'NOT_RELEVANT_ASSESSMENT_BY_YOU',
  RELEVANT_OUTCOME: 'RELEVANT_OUTCOME',
  NOT_SURE_OUTCOME: 'NOT_SURE_OUTCOME',
  NOT_RELEVANT_OUTCOME: 'NOT_RELEVANT_OUTCOME',

  // Full text review assessments only
  INCLUDE_ASSESSMENT_BY_YOU: 'INCLUDE_ASSESSMENT_BY_YOU',
  EXCLUDE_ASSESSMENT_BY_YOU: 'EXCLUDE_ASSESSMENT_BY_YOU',
  INCLUDE_OUTCOME: 'INCLUDE_OUTCOME',
  EXCLUDE_OUTCOME: 'EXCLUDE_OUTCOME',
});
